module.exports = __webpack_public_path__ + "img/应用@2x.b145fc9d.png";